module.exports = __webpack_public_path__ + "img/businessScopeImg2.07c6c049.png";